import { useEffect, useRef } from 'react';

const advantages = [
  {
    icon: 'ri-tools-fill',
    title: 'Instalación Profesional',
    description: 'Nuestro equipo técnico certificado garantiza una instalación segura, rápida y perfecta para cada evento.',
  },
  {
    icon: 'ri-4k-line',
    title: 'Alta Resolución y Brillo',
    description: 'Pantallas con resolución 4K/8K y brillo superior a 5000 nits, perfectas para interiores y exteriores.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Atención Personalizada',
    description: 'Asesoría dedicada desde la cotización hasta el desmontaje. Tu evento es nuestra prioridad.',
  },
  {
    icon: 'ri-time-line',
    title: 'Puntualidad y Confianza',
    description: 'Cumplimos con los tiempos acordados. Llegamos antes para que todo esté listo cuando lo necesitas.',
  },
];

const AdvantagesSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.adv-reveal').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 150);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative bg-[#0a0a0a] py-24 md:py-32 overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-cyan-500/5 blur-3xl pointer-events-none" />

      <div ref={sectionRef} className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 border border-cyan-500/40 bg-cyan-500/10 text-cyan-400 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            ¿Por qué elegirnos?
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Ventajas que nos{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-sky-500">
              distinguen
            </span>
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-sky-500 rounded-full mx-auto mt-4" />
        </div>

        {/* Advantages Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {advantages.map((adv) => (
            <div
              key={adv.title}
              className="adv-reveal flex flex-col items-center text-center group"
              style={{ opacity: 0, transform: 'translateY(40px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}
            >
              {/* Icon circle */}
              <div className="relative w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-cyan-500/20 to-sky-500/10 border border-cyan-500/30 mb-6 group-hover:border-cyan-400 group-hover:bg-cyan-500/25 transition-all duration-300">
                <i className={`${adv.icon} text-cyan-400 text-3xl`} />
                <div className="absolute inset-0 rounded-full bg-cyan-400/10 blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              <h3 className="text-white font-semibold text-lg mb-3">{adv.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed max-w-[220px]">{adv.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom banner */}
        <div className="mt-20 relative rounded-2xl overflow-hidden border border-cyan-500/20">
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 via-sky-500/5 to-cyan-500/10" />
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 px-8 md:px-12 py-8">
            <div>
              <h3 className="text-white font-bold text-xl md:text-2xl mb-2">
                ¿Listo para impresionar a tu audiencia?
              </h3>
              <p className="text-gray-400 text-sm md:text-base">
                Contáctanos hoy y recibe una cotización personalizada sin costo.
              </p>
            </div>
            <button
              onClick={() =>
                window.open(
                  'https://wa.me/525525261379?text=Hola%2C%20me%20interesa%20cotizar%20pantallas%20para%20mi%20evento',
                  '_blank'
                )
              }
              className="flex items-center gap-3 bg-gradient-to-r from-cyan-500 to-sky-600 text-white font-bold px-8 py-4 rounded-full hover:scale-105 hover:shadow-[0_0_30px_rgba(6,182,212,0.4)] transition-all duration-300 cursor-pointer whitespace-nowrap flex-shrink-0"
            >
              <i className="ri-whatsapp-line text-xl" />
              Cotizar Gratis
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
